import UserView from './UserView';
import { PageTitle } from 'app/components';

function UserIndex() {

  const titles = [
    "Cadastro",
    "Usuários",
  ];

  return (
    <div>
      <PageTitle titles={titles} />
      <UserView />
    </div>
  );
}

export default UserIndex;
